import { GalleryControlsDesktop } from './GalleryControlsDesktop/GalleryControlsDesktop'
import { GalleryControlsMobile } from './GalleryControlsMobile/GalleryControlsMobile'

export const GalleryControls = () => (
  <>
    <GalleryControlsMobile />
    <GalleryControlsDesktop />
  </>
)
